<div class="page-content">
    <p-panel header="Customer User Membership management" class="no-x-padding">
        <app-customer-user-membership-crud></app-customer-user-membership-crud>
    </p-panel>
</div>
